import { FunctionComponent, useRef, useEffect } from "react";
import useDevice from "../../utils/hooks/useDevice";

type Props = {
  closeModal: () => void;
};

const VideoModal: FunctionComponent<Props> = ({ closeModal }) => {
  const overlay = useRef(null);
  const event = (e: any) => {
    if (e.key === "Escape") {
      closeModal();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", event);
    return () => {
      window.removeEventListener("keydown", event);
    };
  }, []);

  const handleOverlayClick = (e: any) => {
    if (e.target === overlay.current) {
      closeModal();
    }
  };

  const { width } = useDevice();

  return (
    <section
      className="video_overlay"
      ref={overlay}
      onClick={handleOverlayClick}
    >
      <button onClick={closeModal}>X</button>
      <div className={`video_modal ${width < 900 && `video_modal_mobile`}`}>
        <iframe
          className="video_iframe"
          src="https://www.youtube.com/embed/D_9nVdPOh4c?showinfo=0"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
    </section>
  );
};

export default VideoModal;
